import React from 'react'

export const PostDetailsHelpfulSection = ({
  selectedPost,
  helpfulState,
  handleHelpful,
  articelsHomePageImages,
}) => {
  return (
    <div className="my-20">
      <div className="flex flex-col items-center gap-2 mb-16 lg:mb-32">
        <h2 className="lg:text-4xl">האם התוכן הזה היה מועיל?</h2>
        <h3 className="text-text text-xl">ספרו לנו!</h3>
      </div>

      <div
        className="flex justify-center gap-1 relative"
        role="group"
        aria-label="שאלת שימושיות התוכן"
      >
        {/* כפתור 'כן' */}
        <button
          className={`group flex items-end relative ${
            helpfulState === 'yes'
              ? 'bg-gradient-to-r from-[#ff4242] to-[#1B1B1B]'
              : 'hover:bg-gradient-to-r hover:from-[#ff4242] hover:to-[#1B1B1B]'
          }`}
          onClick={() => handleHelpful('yes')}
          aria-label="לחץ כאן אם המאמר היה מועיל"
          title="מאמר מועיל"
        >
          <img
            src={articelsHomePageImages.yesCharacter}
            alt="דמות אנימה מצב חיובי"
            title="הבעת שביעות רצון"
            className={`w-[100px] h-[100px] absolute right-0 md:w-[150px] md:h-[130px] lg:w-[240px] lg:h-[200px] transition-transform duration-100 ${
              helpfulState === 'yes' ? 'scale-110' : 'group-hover:scale-110'
            }`}
          />
          <span
            className={`text-text lg:text-xl bg-gradient-to-r from-[#3B3B3B] to-[#1B1B1B] w-[160px] md:w-[200px] lg:w-[340px] h-[60px] flex items-center justify-end p-4 md:p-8 ${
              helpfulState === 'yes'
                ? 'bg-gradient-to-r from-[#ff4242] to-[#1B1B1B]'
                : 'group-hover:bg-gradient-to-r group-hover:from-[#ff4242] group-hover:to-[#1B1B1B]'
            }`}
            aria-hidden="true"
          >
            כן{' '}
            {helpfulState === 'yes' &&
              `(${selectedPost.helpful?.yes?.count || 0})`}
          </span>
        </button>

        {/* כפתור 'לא' */}
        <button
          className={`group flex items-end relative ${
            helpfulState === 'no'
              ? 'bg-gradient-to-r from-[#1B1B1B] to-[#ff4242]'
              : 'hover:bg-gradient-to-r hover:from-[#1B1B1B] hover:to-[#ff4242]'
          }`}
          onClick={() => handleHelpful('no')}
          aria-label="לחץ כאן אם המאמר לא היה מועיל"
          title="מאמר לא מועיל"
        >
          <span
            className={`text-text lg:text-xl bg-gradient-to-r from-[#1B1B1B] to-[#3B3B3B] w-[160px] md:w-[200px] lg:w-[340px] h-[60px] flex items-center justify-start p-4 md:p-8 ${
              helpfulState === 'no'
                ? 'bg-gradient-to-r from-[#1B1B1B] to-[#ff4242]'
                : 'group-hover:bg-gradient-to-r group-hover:from-[#1B1B1B] group-hover:to-[#ff4242]'
            }`}
            aria-hidden="true"
          >
            לא{' '}
            {helpfulState === 'no' &&
              `(${selectedPost.helpful?.no?.count || 0})`}
          </span>
          <img
            src={articelsHomePageImages.noCharacter}
            alt="דמות אנימה מצב שלילי"
            title="הבעת אי שביעות רצון"
            className={`absolute left-0 w-[100px] h-[100px] md:w-[150px] md:h-[130px] lg:w-[240px] lg:h-[180px] transition-transform duration-100 ${
              helpfulState === 'no' ? 'scale-110' : 'group-hover:scale-110'
            }`}
          />
        </button>
      </div>
    </div>
  )
}
